import React from 'react'

import '../../styles/scss/elements/deal-banner.scss'

const DealBanner = (props) => {
  const {
    bannerText,
    containerClasses,
    description,
    heading,
    image,
    url,
  } = props

  return (
    <div className={`deal-banner ${containerClasses}`}>
      <button
        className="deal-banner__button"
        onClick={() => (window.location.href = url)}
      >
        <div className="deal-banner__button__top-row-wrapper">
          <div className="deal-banner__button__text">
            <span
              className="deal-banner__button__text-bannerText"
              dangerouslySetInnerHTML={{ __html: bannerText }}
            />
          </div>
          <div className="deal-banner__button__heading">
            <span dangerouslySetInnerHTML={{ __html: heading }} />
          </div>
        </div>
        <div className="deal-banner__button__bottom-row-wrapper">
          <div
            className="deal-banner__button__description"
            dangerouslySetInnerHTML={{ __html: description }}
          />
          <img alt="" src={image.path} className="deal-banner__button__image" />
        </div>
      </button>
    </div>
  )
}

export default DealBanner
